import React, { useState, useEffect } from "react";
import {
  View,
  Dimensions,
  PixelRatio,
  Modal,
  TouchableNativeFeedback,
} from "react-native";
import SuccessIcon from "@assets/svg/SuccessIcon";
import Cross from "@assets/svg/CrossIcon";
import Text from "@components/AppText";
import Button from "@components/Button";

import { useDispatch } from "react-redux";
import { useNavigation } from "@react-navigation/native";

const { width, height } = Dimensions.get("window");
const scale = width / 360;

function normalize(size) {
  const newSize = size * scale;
  return Math.round(PixelRatio.roundToNearestPixel(newSize));
}

const Success = ({ text, onPress, visible, fromLink = false, source = "" }) => {
  const [show, setShow] = useState(false);
  const dispatch = useDispatch();
  const navigation = useNavigation();
  const [loading, setLoading] = useState(false);

  const navigate = () => {
    setLoading(true);
    // to reflect change leader result in refer messages
    navigation.navigate("SelectProduct");
    setLoading(false);

    setShow(false);
  };

  useEffect(() => {
    setShow(visible);
  }, [visible]);

  return (
    <Modal
      animationType="slide"
      transparent={false}
      onRequestClose={navigate}
      //   onDismiss={}
      visible={show}
      presentationStyle="fullScreen"
    >
      <View style={{ flex: 1 }}>
        <TouchableNativeFeedback onPress={navigate}>
          <Cross
            style={{ marginLeft: normalize(12), marginTop: normalize(30) }}
          />
        </TouchableNativeFeedback>

        <View
          style={{
            alignItems: "center",
            justifyContent: "center",
            alignSelf: "center",
            flex: 1,
            width: width * 0.89,
          }}
        >
          <SuccessIcon />
          <Text
            bold
            style={{
              fontSize: normalize(24),
              lineHeight: normalize(34),
              marginVertical: normalize(10),
            }}
          >
            {"Successful!"}
          </Text>

          <Text
            style={{
              textAlign: "center",
              fontSize: normalize(16),
              lineHeight: normalize(24),
              marginTop: normalize(40),
            }}
          >
            {text}
          </Text>
        </View>
        <Button
          btnText="Okay"
          buttonFontType="bold"
          isSubmitting={loading}
          onPress={navigate}
          fontSize={normalize(18)}
          buttonWidth={width * 0.88}
          height={normalize(50)}
          borderRadius={10}
          containerStyle={{ alignSelf: "center", marginBottom: normalize(20) }}
        />
      </View>
    </Modal>
  );
};

export default Success;
